<script lang="ts">
    // @ts-ignore
    import dayjs from "dayjs";
    import { useNavigate } from "svelte-navigator";
    import type {
        CampaignListEntry,
        CampaignWrapperListEntry,
    } from "../../../../../../admin-service-typescript-client";

    const navigate = useNavigate();
    export let campaignEntry: CampaignWrapperListEntry;

    const startEnd = campaignEntry.campaigns.reduce(
        (duration, campaign) => {
            const start = dayjs(campaign.duration.start);
            const end = dayjs(campaign.duration.end);
            if (start.isBefore(duration.start)) {
                duration.start = start;
            }
            if (end.isAfter(duration.end)) {
                duration.end = end;
            }
            return duration;
        },
        {
            start: dayjs(),
            end: dayjs(),
        }
    );

    const active = campaignEntry.campaigns.some((campaign) => campaign.active);
</script>

<div class="column is-12">
    <div class="columns is-vcentered">
        <!-- <div class="column is-2">
                    <figure
                        class="image is-48x48"
                        
                    >
                        <img
                            src={"https://dummyimage.com/600x400/a8a8a8/ffffff.png&text=TBD"}
                            alt="Placeholder"
                        />
                    </figure>
                </div> -->
        <div class="column is-2" />
        <div class="column is-3" on:click={() => navigate(campaignEntry.id)}>
            {campaignEntry.name}
        </div>
        <div class="column is-3">
            {dayjs(startEnd.start).format("DD.MM.YY")} - {dayjs(
                startEnd.end
            ).format("DD.MM.YY")}
        </div>
        <div class="column is-3">
            {active ? "aktiviert" : "deaktiviert"}
        </div>
    </div>
</div>

<style>
    .card {
        margin: 5px 0;
    }

    .column {
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>
